<div class="kt-header__brand   kt-grid__item" id="kt_header_brand">
  <div class="kt-header__brand-logo">
    <a routerLink="/" target="_blank">
      @if (!appSession.tenant || !appSession.tenant.HasLogo()) {
        <img src="/assets/common/images/upm-logo-login.svg" alt="logo" height="38" class="kt-header__brand-logo-default" />
      }
      @if (!appSession.tenant || !appSession.tenant.HasLogo()) {
        <img src="/assets/common/images/upm-logo.svg" alt="logo" height="38" class="kt-header__brand-logo-sticky" />
      }
      @if (appSession.tenant && appSession.tenant.HasLogo()) {
<img [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.HasLogo()" alt="logo" height="38" />
}
        </a>
    </div>
</div>
